// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2ljS9","content":"styles_content__OnJuU","selectAll":"styles_selectAll__1QEMB"};